"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DonationBox = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _checkoutUtils = require("@ori/checkout-utils");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const onDonationActivation = async (choiceId, checked) => {
  try {
    await (0, _hooks.updateDonation)(choiceId, checked);
  } catch (error) {
    if (error instanceof Error) {
      (0, _checkoutUtils.showErrorNotification)();
      _logger.mainLogger.error(error, {
        action: 'onDonationActivation'
      });
    }
  }
};
const DonationBoxComponent = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isChecked
  }
}) => ({
  position: 'relative',
  display: 'block',
  borderRadius: theme.shape.largeComponentRadius,
  cursor: 'pointer',
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.default.main,
  boxShadow: 'none',
  marginBottom: theme.spacing(3),
  transition: 'box-shadow 300ms, border-color 300ms',
  ...(isChecked && {
    border: `1px solid ${theme.palette.background.paper}`,
    boxShadow: theme.shadows[3]
  }),
  ...(!isChecked && {
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        border: `1px solid ${theme.palette.background.paper}`,
        boxShadow: theme.shadows[3]
      }
    }
  })
}));
const Indicator = (0, _mui.styled)('div')(({
  theme,
  ownerState: {
    isChecked
  }
}) => ({
  position: 'absolute',
  top: -1,
  left: -1,
  width: 50,
  height: 50,
  overflow: 'hidden',
  opacity: 0,
  borderTopLeftRadius: theme.shape.largeComponentRadius,
  transition: theme.transitions.create('opacity'),
  '&::before': {
    position: 'absolute',
    top: 0,
    left: 0,
    content: '""',
    transform: 'translate(-50%, -50%) rotate(45deg)',
    width: 50,
    height: 50,
    zIndex: 0,
    background: theme.palette.primary.main
  },
  ...(isChecked && {
    opacity: 1
  })
}));
const CheckHeavyIcon = (0, _mui.styled)(_icons.CheckHeavy)(({
  theme
}) => ({
  position: 'relative',
  left: 1,
  top: 1,
  fontSize: '2rem',
  color: theme.palette.text.primary
}));
const DonationLabel = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(4, 3),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4)
  }
}));
const DonationDescriptionLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  padding: theme.spacing(0, 3, 4),
  color: theme.palette.grey[600],
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 4, 4)
  }
}));
const SectionHeader = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  margin: theme.spacing(6, 0, 3),
  fontWeight: 'bold'
}));
const DonationBox = () => {
  const {
    shoppingContext
  } = (0, _shoppingContext.useShoppingContext)();
  const [isChecked, setIsChecked] = (0, _react.useState)(false);
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const ownerState = {
    isChecked
  };
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const donation = (0, _react.useMemo)(() => shoppingContext?.unitDataCollection.find(x => x.unitName === 'Donation') ?? null, [shoppingContext]);
  const activateDonation = (0, _react.useCallback)(() => {
    if (donation !== null) {
      const checked = !isChecked;
      setIsChecked(checked);
      void onDonationActivation(donation.choiceId, checked);
    }
  }, [donation, isChecked]);
  if (donation === null) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...getTestIdProps(_models.TestId.DonationSection),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(SectionHeader, {
      variant: "body1",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "donation"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(DonationBoxComponent, {
      ownerState: ownerState,
      "aria-checked": isChecked,
      role: "checkbox",
      ...getTestIdProps(_models.TestId.DonationCard),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Indicator, {
        ownerState: ownerState,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckHeavyIcon, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DonationLabel, {
        onClick: activateDonation,
        ...getTestIdProps(_models.TestId.DonationLabel),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          ...getTestIdProps(_models.TestId.DonationMessage),
          children: formatMessage('iWouldLikeToDonate0To1', {
            0: donation.price,
            1: donation.charityName
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DonationDescriptionLabel, {
        ...getTestIdProps(_models.TestId.DonationLongDescription),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "donationLongDescription"
        })
      })]
    })]
  });
};
exports.DonationBox = DonationBox;